// BEWARE: In this file there are similar namings. Don't confuse them
// TODO: Find better namings for interfaces and variables and eliminate implicit any's
interface IStatementsDefinition {
  defaultValue: unknown[];
  statements: unknown[];
}
interface IStatementDefinition {
  condition: string;
  value: any,
  rules: unknown[]
}

export function createStatementsDefinition(subLists: any): any {
  let statementsDefinition: IStatementsDefinition = {
    defaultValue: [],
    statements: []
  };

  if(!subLists) {
    return statementsDefinition;
  }

  subLists.forEach(sublist => {
    if (!sublist.Segment) {
      // the sublist with Segment null or undefined is considered to be the default value
      statementsDefinition.defaultValue = sublist.Games;
    } else {
      let statementDefinition: IStatementDefinition = {
        condition: "AND",
        value: sublist.Games,
        rules: []
      };

      sublist.Segment.forEach(segment => {
        statementDefinition.rules.push(_createStatementsRule(segment));
      });

      statementsDefinition.statements.push(statementDefinition);
    }
  });

  return statementsDefinition;
}

function _createStatementsRule(segment: any): any {
  return {
    id: segment.name,
    operator: "=",
    value:
      segment.value === 1 || segment.value === true || segment.value === "true"
        ? true
        : false // Admin sends 1 for true and 2 for false.
  };
}
